import React, { useState } from "react";
import PropTypes from "prop-types";
import localization from "assets/localization/localization";

const SoftwareInventoryDetail = ({ heading, details }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="panel-card">
      <div className="panel-heading">{heading}</div>
      <div className="panel-body">
        <div className="details-listing">
          <div className="w-100">
            {details.map((obj, index) => (
              <div key={index} className="card mb-2">
                <div 
                  className="card-header" 
                  style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  onClick={() => toggleItem(index)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Software {index + 1}</span>
                    <span>{openIndex === index ? '−' : '+'}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div className="card-body">
                    <div className="details-listing">
                      {obj?.service_name && (
                        <div className="details-list">
                          <strong className="data-title">
                            {localization.mat}
                          </strong>
                          <span className="data-details">
                            {obj?.service_name ? obj.service_name : localization.na}
                          </span>
                        </div>
                      )}
                      <div className="details-list">
                        <strong className="data-title">
                          {localization.quantity}
                        </strong>
                        <span className="data-details">
                          {obj?.quantity ? obj.quantity : localization.na}
                        </span>
                      </div>
                      {obj?.item_unit_price && obj?.item_unit_price !== null && (
                        <div className="details-list">
                          <strong className="data-title">Base Unit Price</strong>
                          <span className="data-details">
                            {obj?.item_unit_price ? obj.item_unit_price : localization.na}
                          </span>
                        </div>
                      )}
                      {obj?.sale_unit_price && obj?.sale_unit_price !== null && (
                        <div className="details-list">
                          <strong className="data-title">Sale Unit Price</strong>
                          <span className="data-details">
                            {obj?.sale_unit_price ? obj.sale_unit_price : localization.na}
                          </span>
                        </div>
                      )}
                      <div className="details-list">
                        <strong className="data-title">
                          {localization.specification}
                        </strong>
                        <span className="data-details">
                          {obj?.specification ? obj.specification : localization.na}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

SoftwareInventoryDetail.propTypes = {
  heading: PropTypes.string,
  details: PropTypes.array
};

export default SoftwareInventoryDetail;
